import { createRouter, createWebHistory } from 'vue-router';
import store from '@/store';  // Ensure the store is correctly imported
import UserLogin from '@/components/UserLogin.vue';
import UserLogout from '@/components/UserLogout.vue';
import HomePage from '@/components/HomePage.vue';
import AdminUser from '@/components/AdminUser.vue';
import ProjectsList from '@/components/ProjectsList.vue';
import ProjectDetails from '@/components/ProjectDetails.vue';  // Component for documents within a project
import DocumentDetails from '@/components/DocumentDetails.vue';  // Component for pages within a document
import PageDetails from '@/components/PageDetails.vue';  // Component for page annotations
import UserProfile from '@/components/UserProfile.vue';
import ProjectDashboard from '@/components/ProjectDashboard.vue';
import AcceptInvite from '@/components/AcceptInvite.vue';
import ForgotPassword from '@/components/ForgotPassword.vue';
import ResetPassword from '@/components/ResetPassword.vue';
import AboutPage from '@/components/AboutPage.vue';
const base = process.env.VUE_APP_ROUTER_BASE || '/';
// Define routes
const routes = [
  { path: '/', component: HomePage,name: 'HomePage' },
  { path: '/login', component: UserLogin },
  { path: '/logout', component: UserLogout },
  { path: '/administrator', component: AdminUser, meta: { requiresAuth: true, requiredRole: 'administrator' } },
  { path: '/about', component: AboutPage, name: 'AboutPage' },
  { path: '/profile', component: UserProfile, meta: { requiresAuth: true } },
  { path: '/projects', component: ProjectsList, meta: { requiresAuth: true } },
  { path: '/projects/:projectId/dashboard', component: ProjectDashboard, meta: { requiresAuth: true } },
  {
    path: '/projects/:projectId',
    component: ProjectDetails,
    //meta: { requiresAuth: true, requiredRole: 'project_leader' }
    meta: { requiresAuth: true, requiredRole: ['transcriber', 'administrator', 'project_leader']  }
  },
  {
    path: '/projects/:projectId/documents/:documentId',
    component: DocumentDetails,
    //meta: { requiresAuth: true, requiredRole: 'project_leader' }
    meta: { requiresAuth: true, requiredRole: ['transcriber', 'administrator', 'project_leader'] }
  },
  {
    path: '/projects/:projectId/documents/:documentId/pages/:pageId',
    component: PageDetails,
    meta: { requiresAuth: true, requiredRole: ['transcriber', 'administrator', 'project_leader'] }
  },
  {
    path: '/accept-invite/:token',
    name: 'accept-invite',
    component: AcceptInvite,
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
  },
  { path: '/reset-password/:token', name: 'ResetPassword', component: ResetPassword },
];

// Create router instance
const router = createRouter({
  history: createWebHistory(base),
  routes,
});

// Add route guard to handle authentication and role-based access
router.beforeEach((to, from, next) => {
  const isAuthenticated = store?.state?.isAuthenticated;
  const userRoles = store?.state?.roles || [];

  // Check if route requires authentication
  if (to.meta.requiresAuth && !isAuthenticated) {
    return next('/login');
  }

  // Check if route has a role restriction
  if (to.meta.requiredRole) {
    const requiredRoles = Array.isArray(to.meta.requiredRole)
      ? to.meta.requiredRole
      : [to.meta.requiredRole];

    const hasRole = requiredRoles.some(role => userRoles.includes(role));
    if (!hasRole) {
      return next('/');  // Redirect if the user doesn't have any of the required roles
    }
  }

  next();  // Proceed if all checks pass
});

export default router;
